import { getRequest } from '../fetchWrapper';

/**
 * Récupération de la liste des ensembles.
 *
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getEnsembleList = (token) => {
    const url = `/api-v1/admin/ensemble/list`
    return getRequest(url, token)
}